var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "success_svg__Success",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.97 59.97"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".success_svg__cls-1{fill:none;stroke:#0000f0;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "success_svg__cls-1",
    d: "M18.98 28.44l8.81 14.23L42.57 18.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "success_svg__cls-1",
    d: "M35 58.55a29 29 0 10-5 .45",
    transform: "translate(-.02 -.02)"
  })));
}
export default SvgSuccess;